import React from 'react'
import { NavLink } from 'react-router-dom'
import { Category } from 'lib/types'

interface Props {
  category: Category
  onClick?: (e: any) => void
  isViewAll?: boolean
}

export const RenderLink = ({ category, onClick, isViewAll }: Props) => {
  return (
    <NavLink
      replace
      to={`/${category.urlPath}`}
      onClick={onClick}
    >
      {isViewAll && 'View All '}
      {category.name}
    </NavLink>
  )
}
